import BaseCard from "../base-card/base-card";

import $ from "jquery";
import VideoModal from "@pj/components/modals/video-modal/video-modal";

export default class VideoCard extends BaseCard {
  constructor(container) {
    super(container);
    this.selector = ".video-card";
  }

  init() {
    super.init();
    this.elements.each((i, e) => {
      const modal = new VideoModal();
      modal.init(`video-modal${$(e).attr('id')}`);
    })
  }
}
